import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import { deleteGroupTemplate } from "Stores/actions/properties/ShopAction";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import * as Icons from "react-bootstrap-icons";

export default function DeletePatternGroup({ row }) {
  const [showAlert, setShowAlert] = useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onShowAlert = () => {
    setShowAlert(!showAlert);
  };

  const onDelete = async () => {
    try {
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      setLoading(true);
      await dispatch(deleteGroupTemplate(data));
      setLoading(false);
    } catch (err) {
      console.error("[catch error]", err);
    }
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="hazf" />}
        icon={<Icons.Trash3 size={17} />}
        className="danger-fill"
        onClick={onShowAlert}
        disabled={!read("settingShopTemplate")?.accessDelete}
      />
      <AlertDialog
        showAlert={showAlert}
        type="alertError"
        onClose={onShowAlert}
        onClickOk={onDelete}
        okTitle={<Translator id="ble_pak_shavad" />}
        cancelTitle={<Translator id="enseraf" />}
        questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
        relationText={<Translator id="relationAlert" />}
        loading={loading}
      />{" "}
    </>
  );
}
